import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Icon from '../../components/common/Icon';
import GuessWho from '../../components/common/GuessWho';

/* Do you know your tribe? — the guess-who, on a screen of its own.

   ★ It used to live ON the community wall, opened by `?quiz=1`. Two different things were sharing
   one screen: the wall is a directory you come to in order to FIND somebody, this is a game you
   come to in order to PLAY it, and a game board above forty face tiles read as clutter to both.
   The wall keeps a one-line door to here, which is all it ever needed to be.

   ★ The identity is in the PATH, not a query param. `usePersistUrlParams` strips the query string
   one tick after mount app-wide, and the old `?quiz=1` survived only because a lazy `useState`
   initializer happened to run first — a reload, a bookmark or a shared link would have landed on
   the wall with the game shut. A route has none of that to be careful about.

   ★ Everything on the screen comes from the ONE `GET /api/company/quiz` the component already
   made: the round, how much of the tribe this player knows, and who the tribe knows best. The
   page is the frame; it fetches nothing of its own. The company and business unit are read off
   the token by the route's gate, so there is nothing to route here either. */
const KnowYourTribe = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Base activeNav="home">
      <Card>
        <Back to="/member-home" />
        <Title my="1" className="mt-3">
          <Icon name="zoom-in" theme="primary" className="me-2" />
          {t('quizTitle')}
        </Title>
        <p className="bravos-q__hint mb-3">{t('quizHomeNote')}</p>

        <GuessWho onOpenPerson={(id) => navigate(`/u/${id}`)} />
      </Card>
    </Base>
  );
};

export default KnowYourTribe;
